"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconGlasses = /*#__PURE__*/
function (_Icon) {
  _inherits(IconGlasses, _Icon);
  function IconGlasses(props) {
    var _this;
    _classCallCheck(this, IconGlasses);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconGlasses).call(this, props));
    _this.name = 'IconGlasses';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "glasses_svg__group0"
    }, _react2.default.createElement("path", {
      className: "glasses_svg__path0",
      d: "M16.499 22.5a2.503 2.503 0 01-2.5-2.5v-3.024A2.005 2.005 0 0012 15c-1.103 0-2 .897-2 2l-.001.021V20c0 1.378-1.121 2.5-2.5 2.5h-5a2.503 2.503 0 01-2.5-2.5v-4L0 15.971V4.5c0-1.654 1.346-3 3-3a.5.5 0 010 1c-1.103 0-2 .897-2 2v9.501a2.485 2.485 0 011.499-.501h5a2.52 2.52 0 012.282 1.485A2.986 2.986 0 0112 14c.854 0 1.653.361 2.217.983a2.521 2.521 0 012.281-1.483h5a2.48 2.48 0 011.501.502V4.5c0-1.103-.897-2-2-2a.5.5 0 010-1c1.654 0 3 1.346 3 3V16l-.001.024V20c0 1.378-1.122 2.5-2.5 2.5h-4.999zm-1.5-2.5c0 .827.673 1.5 1.5 1.5h5c.827 0 1.5-.673 1.5-1.5v-4c0-.827-.673-1.5-1.5-1.5h-5c-.827 0-1.5.673-1.5 1.5v4zm-14 0c0 .827.673 1.5 1.5 1.5h5c.827 0 1.5-.673 1.5-1.5v-4c0-.827-.673-1.5-1.5-1.5h-5c-.818 0-1.49.666-1.499 1.483l-.001.022V20z"
    })));
    return _this;
  }
  return IconGlasses;
}(_Icon3.default);
exports.default = IconGlasses;